<template>
  <div ref="swiperBox"  class="swiperBox">
    <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >
      <swiper-slide v-for="(sliderImage, imageIndex) in images" :key="sliderImage._id" >
          <product-image
            :src="sliderImage.image"
            :alt="sliderImage.name"
            :priority="imageIndex === 0"
            width="600"
            height="600"
            class="mx-auto"
            style="width: 80%; height: auto"
          />
      </swiper-slide>
    </swiper>
  </div>

</template>

<script>
  import 'swiper/dist/css/swiper.min.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import ProductImage from '@/views/components/order-center/ProductImage.vue';

  export default{
    name:'Carousel',
    props:['images'],
    components: {
      swiper,
      swiperSlide,
      ProductImage,
    },
    data(){
      return {
        // Related Products Swiper
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 55,
          breakpoints: {
            1600: {
              slidesPerView: 1,
            },
            1300: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
            900: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },
  };
</script>

<style scoped>
  .swiperBox{
    width:100%;
    position: relative;
  }
  .swiper_btn{
    position: absolute;
  }
</style>
